export enum BlogCategories {
  ARTICLES = 'article',
  REAL_LIFE_STORIES = 'rls',
  VIDEOS = 'video',
  PRODUCT = 'product',
}
